import React from 'react'
import {connect} from 'react-redux'
import * as actions from '../feedback/actions'

import styled from "styled-components"
import Modal from '../common/components/Modal'
import {TextArea} from '../common/components/Input'
import Option from './components/Option'
import { colors } from 'buoy-theme'

const options = [
  {text: "The question is confusing or poorly worded", token: "poorly worded"},
  {text: "The answer options don't apply to me", token: "bad options"},
  {text: "The user experience was bad", token: "UX"},
  {text: "This is taking too long", token: "too long"}
]

const Text = styled(TextArea)`
  margin-top: 14px;
`

const QuestionFeedbackModal = ({flag, cancelFlag, onClose, setComplaint, show, selectOption, selected, onChangeFreetext, freetext, onSubmit, finished, showCovid19AlertBanner}) => (
  <Modal
    heading="Thanks for reporting this. What’s going on?"
    body="Select all that apply."
    buttonText="Okay"
    buttonClick={onSubmit}
    cancelClick={cancelFlag}
    showCovid19AlertBanner={showCovid19AlertBanner}
    questionFeedbackModal={true}
  >
    {options.map((option, i) => (
        <Option
          first={i === 0}
          option={option}
          key={option.text}
          onClick={selectOption}
          color={colors.neutralDarkest}
          selected={selected[option.text]}
        />
    ))}
    <Text
      placeholder="Something else"
      onChange={onChangeFreetext}
      marginTop="1rem"
    />
  </Modal>
)

class QuestionFeedbackModalContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {selected: {}, freetext: '', finished: false}
  }

  selectOption = (option) => {
    this.setState({selected: {...this.state.selected,
      [option.text]: !this.state.selected[option.text]}})
  }

  changeFreetext = (freetext) => {
    this.setState({freetext})
  }

  submitFeedback = () => {
    let feedback = Object.keys(this.state.selected).filter(x => this.state.selected[x]).join(';')
    if (this.state.freetext)
      feedback += ';' + this.state.freetext
    this.props.submitFeedback(feedback)
    this.setState({selected: {}, freetext: '', finished: true})
    this.props.onClose()
  }

  render() {
    if (!this.props.show)
      return <span />
    return (
      <QuestionFeedbackModal
        {...this.state}
        {...this.props}
        selectOption={this.selectOption}
        onChangeFreetext={this.changeFreetext}
        onSubmit={this.submitFeedback}
      />
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  flag: ownProps.flaggedQuestion,
  show: !!state.feedback.flaggedQuestion,
  showCovid19AlertBanner: state.showCovid19AlertBanner
})

const mapDispatchToProps = {
  cancelFlag: actions.cancelFlag,
  onClose: actions.toggleQuestionFlag,
  setComplaint: actions.setQuestionComplaint,
  submitFeedback: actions.submitFlagFeedback
}

const QuestionFeedbackModalWrapper = connect(mapStateToProps, mapDispatchToProps)(QuestionFeedbackModalContainer)

export { QuestionFeedbackModalWrapper as default, QuestionFeedbackModalContainer }



// WEBPACK FOOTER //
// ./assets/modals/QuestionFeedbackModal.js